import {
	ItemType ,
	PermissionType
} from 'phoenix/domain';

/** Represents the definition used to describe actions agnostic of menus that would use them. */
export interface IAppAction{
	action:string;
	label:string;
	icon:string;
	permissions?:PermissionType;
	allowedTypes?:ItemType;
	multiItem?:boolean;
	denyLinkUser?:boolean;
	validOnNull?:boolean;
}

export class AppAction implements IAppAction {
	public get action() {
		return this.config.action;
	} 
	public get label() {
		return this.config.label;
	}
	public get icon() {
		return this.config.icon;
	}
	public get allowedTypes() {
		return angular.isDefined(this.config.allowedTypes) ? 
			this.config.allowedTypes :
			ItemType.None;
	}
	public get permissions(){
		return this.config.permissions;
	}	
	public get multiItem(){
		return !!this.config.multiItem;
	}
	public get denyLinkUser(){
		return !!this.config.denyLinkUser;
	}
	public get validOnNull() {
		return angular.isDefined(this.config.validOnNull) ?
			this.config.validOnNull :
			false;
	}

	constructor(
		private config:IAppAction
	){	
	}
}


// WEBPACK FOOTER //
// ./src/sharebase/domain/appAction.ts